export const CHAT_IMAGE_PREVIEW_TEST_IDS = {
  container: 'chatbot-image-preview',
  image: 'chatbot-image-preview-image',
  skeleton: 'chatbot-image-preview-skeleton',
  error: 'chatbot-image-preview-error',
  retryButton: 'chatbot-image-preview-retry',
  downloadLink: 'chatbot-image-preview-download',
};
